import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../api/snackbarSlice';

export default function CopyTextComponent({ copyText }) {
  const dispatch = useDispatch();

  const handleCopy = () => {
    navigator.clipboard
      .writeText(copyText)
      .then(() => {
        dispatch(showSnackbar({ message: 'Copied to clipboard!', severity: 'success' }));
      })
      .catch((err) => {
        dispatch(showSnackbar({ message: 'Failed to copy:', severity: 'error' }));
      });
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography fontWeight="bold" color="text.secondary">
        {copyText}
      </Typography>
      <Tooltip title="Copy">
        <IconButton size="small" onClick={handleCopy} data-testid="copy-button">
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
